/* Runspire (v28): ordena os tamanhos do seletor da pagina de produto (PP, P, M, G, GG, EG, XG, 3G...). O Shopify define a ordem dos valores pela ordem das variantes, e em varios produtos ela vem embaralhada (poliamida) ou com o M na frente (algodao). So reordena o que ja existe, nao cria nem esconde tamanho. */
(function () {
  var ORDER = ['PP', 'P', 'M', 'G', 'GG', 'EG', 'XG', 'GGG', '3G', 'G2', '4G', 'G3', 'G4'];
  function rank(t) { var i = ORDER.indexOf(String(t).trim().toUpperCase()); return i < 0 ? 99 : i; }
  function fix() {
    document.querySelectorAll('variant-selects fieldset.product-form__input--pill').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend || !/tamanho/i.test(legend.textContent)) return;
      var pairs = [];
      Array.prototype.forEach.call(fs.children, function (el, i) {
        var lab = el.nextElementSibling;
        if (el.tagName === 'INPUT' && el.type === 'radio' && lab && lab.tagName === 'LABEL') pairs.push({ inp: el, lab: lab, i: i, r: rank(el.value) });
      });
      var sorted = pairs.slice().sort(function (a, b) { return a.r - b.r || a.i - b.i; });
      var same = sorted.every(function (p, k) { return p === pairs[k]; });
      if (same) return;
      sorted.forEach(function (p) { fs.appendChild(p.inp); fs.appendChild(p.lab); });
    });
  }
  var queued = false;
  function queue() { if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; fix(); }); } }
  function init() {
    fix();
    var host = document.querySelector('product-info') || document.body;
    new MutationObserver(queue).observe(host, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
